// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 296) return "static/css/296.1f94a0116067c7784c23.lib.css";
	if (chunkId === 172) return "static/css/172.3f8f03d72aabd304face.css";
	// return url for filenames based on template
	return undefined;
};